import { Box, Button, Modal, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { modalStyle } from '@/components/modalStyle';
import { PlanWorkout, TrainingPlan } from '@/generated';
import { useUpdatePlan } from '@/hooks/plan-mutation.hooks';

export const UpdateWorkoutModal = (props: { show: boolean; setShow: (show: boolean) => void; plan: TrainingPlan; workoutUnitId: string; workout: PlanWorkout }) => {
  const { plan, show, setShow } = props;
  const [editWorkout, setEditWorkout] = useState<PlanWorkout>(props.workout);
  const useUpdatePlanMutation = useUpdatePlan();

  useEffect(() => {
    setEditWorkout(editWorkout);
  }, [editWorkout]);

  return (
    <Modal
      open={show}
      onClose={() => {
        setShow(false);
      }}
    >
      <Box sx={modalStyle}>
        <Typography variant="h4">Update Workout</Typography>
        <Stack>
          <TextField
            sx={{ my: 2 }}
            multiline
            label={'Name'}
            value={editWorkout.name}
            onChange={(e) => {
              setEditWorkout({ ...editWorkout, name: e.currentTarget.value });
            }}
          />
          <TextField
            sx={{ my: 2 }}
            multiline
            label={'Description'}
            value={editWorkout.description}
            onChange={(e) => {
              setEditWorkout({ ...editWorkout, description: e.currentTarget.value });
            }}
          />
          &nbsp;
          <Button
            onClick={async () => {
              await useUpdatePlanMutation.mutateAsync({
                notifyUsers: false,
                plan: {
                  ...plan,
                  units: plan.units.map((g) =>
                    g.idClient === props.workoutUnitId ? { ...g, workouts: g.workouts.map((wu) => (wu.idClient === editWorkout.idClient ? editWorkout : wu)) } : g,
                  ),
                },
              });
              setShow(false);
            }}
          >
            Save
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
